import { useState } from "react";
import { useTick } from "@/hooks/use-tick";

export function useOscillatingCount(min: number, max: number, playing = true) {
  const [state, setState] = useState({ dir: 1, value: min });

  useTick(() => {
    setState(({ dir, value }) => {
      let nextDir = dir;
      if (value >= max) {
        nextDir = -1;
      }
      if (value <= min) {
        nextDir = 1;
      }
      return { dir: nextDir, value: value + nextDir };
    });
  }, playing);

  return state.value;
}
